import { AddressDialogComponent } from "./my-customers/address-dialog/address-dialog.component";
import { CustomersService } from "./services/customer.service";
// import { CustomerEditDialogComponent } from './my-customers/customer-edit/customer-edit.dialog.component';
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoginWithOtpComponent } from "./login-with-otp/login-with-otp.component";
import { HomeComponent } from "./home/home.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogRef } from "@angular/material/dialog";
import { DateAdapter } from "@angular/material";
import {MAT_DIALOG_DATA,  MAT_DATE_FORMATS,} from "@angular/material";
import {MatTabsModule} from '@angular/material/tabs';
import { OtpConfirmationComponent } from "./login-with-otp/otp-confirmation/otp-confirmation.component";
import { MyReferralComponent } from "./my-referral/my-referral.component";
import { MyBusinessComponent } from "./my-business/my-business.component";
import { ReferralService } from "./services/referral.service";
import { BusinessService } from "./services/business.service";
import { AddReferralComponent } from "./my-referral/add-referral/add-referral.component";
import { MyreferralViewDialogComponent } from "./my-referral/myreferral-view-dialog/myreferral-view-dialog.component";
import { MyReferralReasonDialogComponent } from "./my-referral/my-referral-reason-dialog/my-referral-reason-dialog.component";
import { ViewComponent } from "./view/view.component";
import { ToastrModule } from "ngx-toastr";
import { MybusinessViewDialogComponent } from "./my-business/mybusiness-view-dialog/mybusiness-view-dialog.component";
import { ExcelService } from "./services/excel.service";
import { MybusinessRejectDialogComponent } from "./my-business/mybusiness-reject-dialog/mybusiness-reject-dialog.component";
import { AppDateAdapter,APP_DATE_FORMATS,} from "./my-business/format-datepicker";
import { MyCustomersComponent } from "./my-customers/my-customers.component";
import { CustomerEditDialogComponent } from "./my-customers/customer-edit/customer-edit.dialog.component";
import { AgmCoreModule } from '@agm/core';
import { ReferralregisterComponent } from "./login-with-otp/referralregister/referralregister.component";
import { JwtInterceptor } from "./utils/interceptor.service";
import { MycustomersViewDialogComponent } from './my-customers/mycustomers-view-dialog/mycustomers-view-dialog.component';
import { HeaderComponent } from './home/header/header.component';
import { ForgetReferralComponent } from './login-with-otp/forget-referral/forget-referral.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomerTimelineComponent } from './my-customers/customer-timeline/customer-timeline.component';
import { TimelineComponent } from './my-customers/customer-timeline/timeline/timeline.component';
import { DetailsComponent } from './my-customers/customer-timeline/details/details.component';
import { FilterComponent } from './partials/filter/filter.component';
import { CoreModule } from "./core/core.module";
import { TranslateModule } from '@ngx-translate/core';
import { CustomerInsightComponent } from './my-customers/customer-timeline/customer-insight/customer-insight.component';
import { BarChartComponent } from './my-customers/customer-timeline/customer-insight/graph-compnent/bar-chart/bar-chart.component';
import { DoughnutChartComponent } from './my-customers/customer-timeline/customer-insight/graph-compnent/doughnut-chart/doughnut-chart.component';
import { LineChartComponent } from './my-customers/customer-timeline/customer-insight/graph-compnent/line-chart/line-chart.component';
import { PieChartComponent } from './my-customers/customer-timeline/customer-insight/graph-compnent/pie-chart/pie-chart.component';
import { VistMetricsComponent } from './my-customers/customer-timeline/customer-insight/visit-metrics/vist-metrics.component';
import { ChartsModule,ThemeService  } from 'ng2-charts';
import { OpportunityMetricsComponent } from './my-customers/customer-timeline/customer-insight/opportunity-metrics/opportunity-metrics.component';
import { OrderMetricsComponent } from './my-customers/customer-timeline/customer-insight/order-metrics/order-metrics.component';
import { ReferralMetricsComponent } from './my-customers/customer-timeline/customer-insight/referral-metrics/referral-metrics.component';
import { VisitAndTaskMetricsComponent } from './my-customers/customer-timeline/customer-insight/visit-and-task-metrics/visit-and-task-metrics.component';
import { MatCardModule } from '@angular/material/card'; 
import {MatCheckboxModule} from '@angular/material/checkbox';
import { BarchartVerticalLoaderComponent } from './my-customers/customer-timeline/customer-insight/graph-skeleton-loader/barchart-vertical-loader/barchart-vertical-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CustomStringToDatePipe } from "./pipes/custom-string-to-date.pipe";
import { PercentageDirective } from "./directives/percentage.directive";
import { DialogComponent } from "./my-customers/customer-timeline/timeline/dialog/dialog.component";
import { ImageViewerModule } from 'ngx-image-viewer';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    LoginWithOtpComponent,
    HomeComponent,
    OtpConfirmationComponent,
    MyReferralComponent,
    MyBusinessComponent,
    AddReferralComponent,
    CustomStringToDatePipe,   // Add your pipe here
    PercentageDirective,
    MyreferralViewDialogComponent,
    MyReferralReasonDialogComponent,
    ViewComponent,
    MybusinessViewDialogComponent,
    MybusinessRejectDialogComponent,
    MyCustomersComponent,
    CustomerEditDialogComponent,
    AddressDialogComponent,
    ReferralregisterComponent,
    MycustomersViewDialogComponent,
    HeaderComponent,
    ForgetReferralComponent,
    CustomerTimelineComponent,
    TimelineComponent,
    DetailsComponent,
    FilterComponent,
    CustomerInsightComponent,
    BarChartComponent,
    DoughnutChartComponent,
    LineChartComponent,
    PieChartComponent,
    VistMetricsComponent,
    OpportunityMetricsComponent,
    OrderMetricsComponent,
    ReferralMetricsComponent,
    VisitAndTaskMetricsComponent,
    BarchartVerticalLoaderComponent,
    DialogComponent,
    
  ],

  imports: [
    BrowserModule,
    MatCardModule,
    TranslateModule.forRoot(),
    CoreModule,
    MatTooltipModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatGridListModule,
    MatDialogModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSidenavModule,
    ToastrModule.forRoot(),
    NgbModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatIconModule,
    RouterModule,
    MatDialogModule,
    MatTabsModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAeaVCOcEf0xlauW7fo_okZt_hChJgZ-l8",
      libraries: ["places"],
    }),
    ChartsModule,
    MatCheckboxModule,
    NgxSkeletonLoaderModule,
    ImageViewerModule
    // PortletModule
    // MatDatepicker
  ],
  entryComponents: [
    AddReferralComponent,
    MyreferralViewDialogComponent,
    MyReferralReasonDialogComponent,
    MybusinessViewDialogComponent,
    MybusinessRejectDialogComponent,
    CustomerEditDialogComponent,
    AddressDialogComponent,
    MycustomersViewDialogComponent,
    HeaderComponent,
    DialogComponent
  ],
  providers: [
    ReferralService,
    BusinessService,
    CookieService,
    CustomersService,
    ExcelService,
    ThemeService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide:HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
